import { createAsyncThunk } from '@reduxjs/toolkit';

export const closeModalSignature = createAsyncThunk(
  'closeModalSignature',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {};
  }
);

export default closeModalSignature;
